import { render } from "./Layout.vue?vue&type=template&id=46dcbbb0&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=46dcbbb0&lang=css"

import exportComponent from "/Users/barry/www/my/www/bi/portal-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__